import { CabinClass } from "./AvailabilityRequest";

export enum SeatMapItemType { EXR, Seat, Aisle }
export enum SeatStatus { Free, Hold, CabinBlock, FABlock, FMBlock, FSGBlock, HardBlock, Infant, Occupied, Protected, Reserved, TemporaryBlock, WebBlock }

export interface IAirCheckinSeatMapItem {
    deckNo?: number;
    rowId: number;
    columnId: number;
    rowTitle?: string;
    columnTitle?: string;
    zone?: string;
    seatNumber?: string;
    positionCode: string;
    wing?: boolean;
    classOfService?: CabinClass;
    itemType: SeatMapItemType;
    seatStatus?: SeatStatus;
    hasInfant?: boolean;
}